const utcDateFormatter = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  month: "short",
  day: "numeric",
  year: "numeric",
});

// DESIGN.md motion: 120ms press scale, 200ms color fades; reduced motion keeps only the fades.
export const pressFeedback = {
  transition: "transform 120ms cubic-bezier(0.2, 0, 0, 1), background-color 200ms linear, border-color 200ms linear",
  _hover: {bg: "n.200"},
  _active: {bg: "n.300", transform: "scale(0.96)"},
  _mediaReduceMotion: {transition: "background-color 200ms linear, border-color 200ms linear"},
} as const;

export const textButtonStyle = {
  ...pressFeedback,
  variant: "ghost",
  h: 10,
  px: 3,
  rounded: "lg",
  fontSize: "sm",
  fontWeight: "semibold",
  color: "brandPurple.500",
} as const;

export const headerCellStyle = {
  py: 2,
  color: "n.400",
  fontFamily: "inherit",
  fontWeight: "semibold",
} as const;

// Chakra's simple variant draws dark-mode dividers; the frame's own border closes the last row. Cell padding stays
// under the fixed 48px row height so a refund button does not make its row taller than the rest.
export const tableSx = {
  "th, td": {borderColor: "n.300"},
  td: {py: 1, fontVariantNumeric: "tabular-nums"},
  "tbody tr:last-of-type td": {borderBottomWidth: 0},
} as const;

export type StatusTone = "paid" | "processing" | "failed" | "refunded";

export const statusToneStyles: Record<StatusTone, {bg: string; color: string}> = {
  paid: {bg: "transparent", color: "n.400"},
  processing: {bg: "sunsetAmber.100", color: "sunsetAmber.800"},
  failed: {bg: "bloodCrimson.100", color: "bloodCrimson.600"},
  refunded: {bg: "n.300", color: "n.700"},
};

export const chipStyle = {
  rounded: "full",
  px: 2,
  lineHeight: 5,
  fontSize: "xs",
  fontWeight: "semibold",
  textTransform: "none",
} as const;

export const formatUtcDate = (iso: string): string => utcDateFormatter.format(new Date(iso));
export const formatCredits = (credits: number): string => credits.toLocaleString("en-US");
